"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLayout = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var Orientation;
(function (Orientation) {
    Orientation["Horizontal"] = "+x";
    Orientation["Vertical"] = "+y";
})(Orientation || (Orientation = {}));
var AppLayout = function (props) {
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArray([
        "l-app",
        props.gap ? "+gap-" + props.gap : "",
        props.orientation
    ], utilityClasses);
    return react_1.default.createElement("div", { className: classes.join(" ") }, props.children);
};
exports.AppLayout = AppLayout;
var Position;
(function (Position) {
    Position["Start"] = "+start";
    Position["Middle"] = "+middle";
    Position["End"] = "+end";
})(Position || (Position = {}));
var AppLayoutItem = function (props) {
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArray(["l-app__item", props.position], utilityClasses);
    return (react_1.default.createElement("div", { className: classes.join(" "), style: props.style }, props.children));
};
var AppLayoutWrap = function (props) {
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArray(["l-app__wrap", props.gap ? "+gap-" + props.gap : ""], utilityClasses);
    return react_1.default.createElement("div", { className: classes.join(" ") }, props.children);
};
AppLayoutItem.Position = Position;
exports.AppLayout.Wrap = AppLayoutWrap;
exports.AppLayout.Orientation = Orientation;
exports.AppLayout.Item = AppLayoutItem;
//# sourceMappingURL=AppLayout.js.map